import React from 'react';
import { Link } from 'react-router-dom'; // Import the Link component from React Router

// Import images
import footerLogo from '../../../assets/images/resources/logo.png'; // Replace with your actual path
import footerBgShape from '../../../assets/images/shapes/site-footer-two-bg-shape.png'; // Replace with your actual path

const FooterTwo = () => {
    return (
        <footer className="site-footer-two">
            <div 
                className="site-footer-two__bg-shape float-bob-y"
                style={{ backgroundImage: `url(${footerBgShape})` }}
            ></div>
            <div className="site-footer-two__top">
                <div className="container">
                    <div className="site-footer-two__top-inner">
                        <div className="row">
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                                <div className="footer-widget-two__column footer-widget-two__about">
                                    <div className="footer-widget-two__logo">
                                        <Link to="/">
                                            <img src={footerLogo} alt="Footer Logo" />
                                        </Link>
                                    </div>
                                    <p className="footer-widget-two__about-text">
                                    TechTotalers is a global IT consulting services provider. We focus on delivering high value to clients through integrated, robust, responsive and cost-effective solutions.
                                    </p>
                                    <div className="footer-widget-two__social">
                                        <Link to="https://www.linkedin.com/in/techtotalers-private-limited-020b0a248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><span className="icon-linkedin-in"></span></Link>
                                        {/* <Link to="#"><span className="icon-Vector"></span></Link>
                                        <Link to="#"><span className="icon-instagram"></span></Link>
                                        <Link to="#"><span className="icon-pinterest"></span></Link> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                <div className="footer-widget-two__column footer-widget-two__contact">
                                    <div className="footer-widget-two__title-box">
                                        <h3 className="footer-widget-two__title">Services</h3>
                                    </div>
                                    <div className="footer-widget-two__contact-inner">
                                        <ul className="footer-widget-two__contact-list list-unstyled">
                                            <li>
                                                {/* <div className="icon">
                                                    <span className="icon-envelope"></span>
                                                </div> */}
                                                <div className="text">
                                                    <p><a href="/security-consulting">Security Consulting</a></p>
                                                </div>
                                            </li>
                                            <li>
                                                {/* <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div> */}
                                                <div className="text">
                                                <p><a href="/audit-&-compliance">Audit and Compliance</a></p>
                                                </div>
                                            </li>
                                            <li>
                                                {/* <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div> */}
                                                <div className="text">
                                                <p><a href="/cloud-security">Cloud Security</a></p>
                                                </div>
                                            </li>
                                            <li>
                                                {/* <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div> */}
                                                <div className="text">
                                                <p><a href="/design-&-implementation">Design and Implementation</a></p>
                                                </div>
                                            </li>
                                            <li>
                                                {/* <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div> */}
                                                <div className="text">
                                                <p><a href="/managed-it-services">Managed IT Services</a></p>
                                                </div>
                                            </li>
                                            {/* <li>
                                                <div className="icon">
                                                    <span className="icon-call"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="tel:01245789321">01245789321</a>, <a href="tel:012457895146">012457895146</a></p>
                                                </div>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                <div className="footer-widget-two__column footer-widget-two__contact">
                                    <div className="footer-widget-two__title-box">
                                        <h3 className="footer-widget-two__title">Contact</h3>
                                    </div>
                                    <div className="footer-widget-two__contact-inner">
                                        <ul className="footer-widget-two__contact-list list-unstyled">
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-envelope"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="mailto:debra.holt@example.com">info@techtotalers.in</a></p>
                                                </div>
                                            </li>
                                            {/* <li>
                                                <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div>
                                                <div className="text">
                                                    <p>Showbhagya Amulya Complex</p>
                                                </div>
                                            </li> */}
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-call"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="tel:+91 80969 62555">+91 80969 62555</a></p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                                <div className="footer-widget-two__column footer-widget-two__newsletter">
                                    <p className="footer-widget-two__newsletter-title"><span>Subscribe</span> to Our<br /> Newsletter</p>
                                    <form className="footer-widget-two__newsletter-form mc-form" data-url="MC_FORM_URL" noValidate>
                                        <div className="footer-widget-two__newsletter-form-input-box">
                                            <input type="email" placeholder="Your e-mail" name="EMAIL" />
                                            <button type="submit" className="footer-widget-two__newsletter-btn"><span className="icon-paper-plane"></span></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="site-footer-two__bottom">
                <div className="container">
                    <div className="site-footer-two__bottom-inner">
                        <p className="site-footer-two__bottom-text">Copyright @ 2025 TechTotalers | All Rights Reserved.</p>
                        {/* <ul className="list-unstyled site-footer-two__bottom-menu">
                            <li><Link to="/about">Terms & Conditions</Link></li>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                        </ul> */}
                    </div>
                </div>
            </div>
          



        </footer>
    );
};

export default FooterTwo;
